<template>
  <div>
  <!--Modal-->
    <LockerCredentials v-if="!accessEnabled" ref="modalSafe" @accessSafe="accessSafe" :accessEnabled="accessEnabled" :isEmailCodeRequired="lockerSettings.isEmailCodeRequired" :is2faCodeRequired="lockerSettings.is2faCodeRequired" :isSMSCodeRequired="lockerSettings.isSMSCodeRequired" :loading="loading" :activePhone="activePhone"/>
    <Onboarding ref="refOnboarding"/>
    <!--content-->
    <main v-if="accessEnabled" class="container-fluid">
      <div class="row">
        <div class="col-4 px-3 pt-3 d-none d-md-flex"></div>
        <div class="col-24 col-md-16 px-3 pt-3">
          <h1 class="title pt-2 mb-0" v-text="$ml.get('repTitle')"></h1>
          <h1 class="title">
            <span v-text="$ml.get('repSubTitle')" class="pb-2"></span>
          </h1>
        </div>
      </div>
      <reportLocker filter="all" @lockSafe="requestCredential" />
    </main>
  </div>
</template>

<script>
import store from '../../../state/store'
import reportLocker from "../../../components/report/reportLocker";
import LockerCredentials from "../../../components/modais/LockerCredentials.vue";
import accountService from "../../../services/account.service";
import Onboarding from "../../../components/Onboarding.vue";


export default {
  components: {
    reportLocker,
    LockerCredentials,
    Onboarding
  },
  data() {
    return {
      title: "Report",
      accessEnabled: false,

      lockerSettings:{
        isEmailCodeRequired: false,
        is2faCodeRequired: false,
        isSMSCodeRequired:false,
      },
     
      loading:true,

      // Variaveis da conta da empresa
      activePhone: false,
      isTwoFactorAuthenticationEnabled:false,
    };
  },
  watch: {
    '$store.state.tokenSafe': function (value) {
      if (!value) this.accessEnabled = false;
    },
  },
  methods: {
    async getAccount(){
      try {
        const {data} = await accountService.getAccountMy();
        const {isEmailCodeRequired, is2faCodeRequired, isSMSCodeRequired, lockerPassword, isTwoFactorAuthenticationEnabled, activePhone} = data.lockerSettings
        this.lockerSettings.isEmailCodeRequired = isEmailCodeRequired;
        this.lockerSettings.is2faCodeRequired = is2faCodeRequired;
        this.lockerSettings.isSMSCodeRequired = isSMSCodeRequired;
        this.isTwoFactorAuthenticationEnabled = isTwoFactorAuthenticationEnabled;
        this.activePhone = activePhone;
        this.loading = false;

        const token = localStorage.getItem('token_safe') ?? "";

        if(!this.activePhone && isSMSCodeRequired && !token.length){
          this.$refs.refOnboarding.startMenu();
          return;
        }
        if(!this.isTwoFactorAuthenticationEnabled && is2faCodeRequired && !token.length){
          this.$refs.refOnboarding.startMenu();
          return;
        }
        if(!lockerPassword && !token.length){
          this.$refs.refOnboarding.startMenu();
          return;
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    requestCredential() {
      localStorage.setItem('token_safe', '')
      localStorage.removeItem('remainingTime');
      store.dispatch('setTokenSafe', '');
      store.dispatch("setSafeTimeInactive", "");

      this.accessEnabled = false;
    },
    accessSafe(){
      const token = localStorage.getItem('token_safe') ?? "";
      if(!token.length){
        console.log(store.state.safeTimeInactive);
        this.requestCredential()
        return;
      }
      this.accessEnabled = true;
    }
  },
  mounted() {
    this.getAccount();
    this.accessSafe()
  }
};
</script>
